module.exports = __webpack_public_path__ + "img/company.9e7cf511.svg";